export const translationCodes = {
	importWizardStep1: 108,
	importWizardStep2: 109,
	action: 111,
	documentTitleFileUpload: 112,
	importNoChanges: 135,
	uploadTranslations: 136,
	undefined: 157,
	plural: 332,
	singular: 513,
	searchTip: 514,
	copiedToClipBoard: 10818,
	addTranslation: 10819,
	englishTranslation: 10820,
	created: 10821,
	lastUpdated: 10822,
	deleteTranslation: 10823,
	deleteTranslationConfirmation: 10824,
	translationNamePlaceholder: 11087,
	createdBy: 11092,
	updatedBy: 11094,
	en: 11301,
	nl: 11302,
	de: 11303,
	pl: 11304,
	hr: 11305,
	sk: 11306,
	ro: 11307,
	es: 14206,
	homePage: 4477,
};
